
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class StellarNurseryEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const clouds = Math.floor(10 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.fillStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < clouds; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 1) - 0.5) * height * 2;
                
                // Intense focal points (new stars)
                const pulse = (Math.sin(curTime * 2 + i) + 1) * 0.5;
                const r = (50 + this.pseudoRandom(i + 2) * 50) * scale * (1 / (layerIndex + 1));
                
                ctx.save();
                ctx.globalAlpha *= 0.4 + pulse * 0.6;
                const grad = ctx.createRadialGradient(rx, ry, 0, rx, ry, r);
                grad.addColorStop(0, pc.color);
                grad.addColorStop(1, 'transparent');
                ctx.fillStyle = grad;
                ctx.beginPath();
                ctx.arc(rx, ry, r, 0, Math.PI * 2);
                ctx.fill();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
